import { PureConnect, React } from '../../react';
import { searchTermSelector } from './selectors';

import windowSelectors from '../../window/selectors';

import TERM from './actions/TERM';

import cx from './admin-style.less';
import adminReselectors from '../admin/reselectors';
import { presentationButtonSelector } from '../admin/selectors';
import TILE_PRESENTATION from '../admin/actions/TILE_PRESENTATION';
import LIST_PRESENTATION from '../admin/actions/LIST_PRESENTATION';
import { IEntityNote } from '../../types';

const bigInputViewportWidthThreshold = 1024;
const typeNotes=0;
const typeQuestions=1;
const typeBookmarks=2;
const typeCategories=3;
const typeUserGroups=4;
const typeUserAdmin=5;

export const InputFilter = PureConnect<any>('InputFilter')(
    (state) => ({
        listpresentation: presentationButtonSelector(state),
        searchTerm: searchTermSelector(state),
        windowWidth: windowSelectors.width(state),
        screenSmall: windowSelectors.small(state),
        notes: adminReselectors.notesItemsSelector(state).concat(adminReselectors.notesSharedSelector(state))
                .concat(adminReselectors.questionsItemsSelector(state)),        
        bookmarks: adminReselectors.bookmarksItemsSelector(state),
        categories: adminReselectors.categoriesItemsSelector(state),
        usergroups: adminReselectors.usergroupSelector(state),
        usergroupsWitMeInIt: adminReselectors.usergroupWitMeInItSelector(state),
    }),
    (dispatch) => ({
        updateSearchTerm: (searchTerm: string) => dispatch(TERM({ searchTerm })),
        tilePresentation: () => {
            dispatch(TILE_PRESENTATION({ }));},
        listPresentation: () => { 
             dispatch(LIST_PRESENTATION({ }));},
    }),
    ({ listpresentation, updateSearchTerm, tilePresentation, listPresentation, searchTerm, windowWidth, screenSmall, notes, bookmarks, categories, usergroups, usergroupsWitMeInIt, type }) => {
        
        let count = type===typeNotes ? (notes&&notes.length? (notes as IEntityNote[]).qWhere((x) => !x.isquestion).length:0):
                    type=== typeQuestions ? (notes&&notes.length?  (notes as IEntityNote[]).qWhere((x) => x.isquestion).length:0):
                    type===typeBookmarks ? (bookmarks&&bookmarks.length? bookmarks.length:0):
                    type===typeCategories ? (categories&&categories.length ? categories.length:0): 
                    type===typeUserGroups ? ((usergroups&&usergroups.length ? usergroups.length:0) +
                                             (usergroupsWitMeInIt && usergroupsWitMeInIt.length? usergroupsWitMeInIt.length:0)):0;

        if (type === typeUserAdmin) {
            return null;
        } else
            return (
                <div className={cx('input-container', 
                    screenSmall? 'input-container-small': 'input-container-big',
                    { big: windowWidth > bigInputViewportWidthThreshold })}>
                    <span className={cx('result')}><span className={cx('result-count')}>{count}</span> Resultaten</span>
                    <span className={cx('v-devider')}></span>
                    {type === typeNotes ? <button 
                        className={cx('btn', 'icon-btn', 'list', (listpresentation? 'active': ''), (type===typeNotes ? '': 'wcag-invisible'))} 
                        aria-label={`Tonen lijstpresentatie`}                                  
                        tabIndex={0} 
                        onClick={() => { listPresentation(); }}>
                        <span aria-hidden="true" className={cx('icon-list')}></span>
                    </button> : ' '}
                    
                    {type === typeNotes ? <button 
                        className={cx('btn', 'icon-btn', 'tile', (listpresentation? '': 'active'),  (type===typeNotes? '': 'wcag-invisible'))} 
                        aria-label={`Tonen tegelpresentatie`}                  
                        tabIndex={0} 
                        onClick={() => { tilePresentation(); }}>
                        <span aria-hidden="true" className={cx('icon-tile')}></span>
                    </button>: ' '}          
                    <span className={cx('v-devider', (type===typeNotes ? '': 'wcag-invisible'))}></span>
                    <span className={cx('search-label')}>Filter op trefwoord</span>  
                    <input className={cx('search-input')} placeholder="Zoeken" name="q" ref="term" value={searchTerm} onChange={(x) => updateSearchTerm(x.target.value)} />                
                </div>
            );
});



// WEBPACK FOOTER //
// (webpack)-remove-block-loader??ref--5-0!./src/note/filter/inputfilter.tsx